<ng-template #pontoCriticoAcao>
  <div class="info-page">
    <h3>{{ actionLabel }} Situação</h3>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()">
    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Status Atual</label>
        <ng-select id="status" class="ng-select-alternative" [items]="list?.status" bindLabel="label" bindValue="id"
          placeholder="Selecione" [formControlName]="typeStatusForm()">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired(typeStatusForm())"
          [erros]="fieldErros(typeStatusForm())"></app-field-message>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 m-b">
        <label class="col-sm-12 pb-1">{{this.list?.start_label}}</label>
        <input id="dt_start_action" class="form-control" formControlName="dt_start_action">
      </div>

      <div class="col-sm-4 m-b">
        <label class="col-sm-12 pb-1">{{this.list?.deadline_label}}</label>
        <input id="dt_deadline" class="form-control" formControlName="dt_deadline">
      </div>
    </div>

    <div class="form-group row m-b" *ngIf="!this.list?.start">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Previsão de Início</label>
        <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_start"
          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_start')">
        <app-field-message [field]="fieldMessageRequired('dt_start')"
          [erros]="fieldErros('dt_start')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">{{form.get(typeStatusForm()).value | formatStatusAndamento:true}}</label>
        <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="deadline"
          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'deadline')"
          [ngClass]="{'ng-invalid': dataFinal}">
        <app-field-message [field]="fieldMessageRequired('deadline') || dataFinal" [erros]="fieldErros('deadline')"
          [textErroServer]="dataFinal"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-8">
        <label class="col-sm-12 pb-1">Situação</label>
        <textarea id="description" class="form-control" rows="3" formControlName="description"
          placeholder="Descrição da Situação" maxlength="400"></textarea>
        <app-field-message [field]="fieldMessageRequired('description')"
          [erros]="fieldErros('description')"></app-field-message>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
        <button class="btn btn-primary" type="submit">Salvar</button>
      </div>
    </div>
  </form>
  <br>
</ng-template>

<div class="wrapper wrapper-content animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <ng-container *ngTemplateOutlet="pontoCriticoAcao"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>